import type { InjectionKey } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'

export interface AppValidationRules {
  phone?: Rule[]
}

export const VALIDATION_RULES_KEY: InjectionKey<AppValidationRules> = Symbol('VALIDATION_RULES_KEY')
